import React from "react";
import logo from "../assets/logo.png";

export default function Login() {
  return (
    <div style={s.page}>
      <div style={s.card}>
        <img src={logo} alt="Companhia das Soluções" style={s.logo} />
        <h1 style={s.title}>Report Dashboard</h1>
        <p style={s.sub}>Acesso restrito a colaboradores da Companhia das Soluções</p>
        <a href="/auth/login" style={s.btn}>
          <MicrosoftIcon />
          Entrar com Microsoft
        </a>
      </div>
    </div>
  );
}

function MicrosoftIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 21 21" style={{ flexShrink: 0 }}>
      <rect x="1"  y="1"  width="9" height="9" fill="#f25022" />
      <rect x="11" y="1"  width="9" height="9" fill="#7fba00" />
      <rect x="1"  y="11" width="9" height="9" fill="#00a4ef" />
      <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
    </svg>
  );
}

const s = {
  page: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    backgroundColor: "#f8fafc",
    fontFamily: "'Segoe UI', system-ui, sans-serif",
  },
  card: {
    backgroundColor: "#ffffff",
    borderRadius: 12,
    border: "1px solid #e2e8f0",
    padding: "48px 40px",
    textAlign: "center",
    maxWidth: 360,
    width: "100%",
  },
  logo: {
    maxWidth: 180,
    marginBottom: 24,
  },
  title: {
    fontSize: 20,
    fontWeight: 700,
    color: "#1e293b",
    margin: "0 0 8px",
  },
  sub: {
    fontSize: 13,
    color: "#94a3b8",
    margin: "0 0 32px",
    lineHeight: 1.5,
  },
  btn: {
    display: "inline-flex",
    alignItems: "center",
    gap: 10,
    backgroundColor: "#0f172a",
    color: "#ffffff",
    padding: "12px 24px",
    borderRadius: 8,
    textDecoration: "none",
    fontSize: 14,
    fontWeight: 600,
    transition: "background 0.15s",
  },
};
